import { d3 } from './d3';

/**
 * Logger decorator collection
 *
 * @example
 * @loggerDecorator.debug.d3()
 * syncMethod() {
 *  // Sync method code
 * }
 *
 * @loggerDecorator.debug.d3({ message: 'Custom message' })
 * async asyncMethod() {
 *  // Async method code
 * }
 */
export const loggerDecorator = {
  /**
   * Debug-level logging decorators
   */
  debug: {
    /* D3 method decorator for logging method completion */
    d3: d3
  }
};
